var CAROUSEL_CONSTANTS = {
  /**
   * Threshold for determining if a slide is considered "in view"
   * Value between 0 and 1, where 0.3 means 30% of the slide must be visible
   */
  IN_VIEW_THRESHOLD: 0.3,
  /**
   * Debounce delay in milliseconds for aria attribute updates
   * Prevents excessive DOM updates during rapid scrolling
   */
  ARIA_UPDATE_DEBOUNCE_DELAY: 300
};

export { CAROUSEL_CONSTANTS };
//# sourceMappingURL=constants.js.map
